import { useEffect, useState } from 'react';
import { Modal, Form, Select, Radio, Input, App } from 'antd';
import { documentService } from '@/services/documentService';
import { userService } from '@/services/userService';

interface Props {
  documentId: string;
  onClose: () => void;
  onSubmitted: () => void;
}

export function SubmitApprovalModal({ documentId, onClose, onSubmitted }: Props) {
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setLoading(true);
    userService.list({ pageSize: 1000 })
      .then(r => setUsers(r.items))
      .catch(() => message.error('Không tải được user'))
      .finally(() => setLoading(false));
    form.setFieldsValue({ workflow: 'SEQUENTIAL' });
  }, []);

  const submit = async () => {
    const v = await form.validateFields();
    setSubmitting(true);
    try {
      await documentService.submitForApproval(documentId, v.approverIds, v.workflow, v.comment);
      message.success('Đã gửi yêu cầu phê duyệt');
      onSubmitted();
    } catch (e: any) {
      message.error(e.response?.data?.message ?? 'Lỗi');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open
      title="Gửi phê duyệt"
      onCancel={onClose}
      onOk={submit}
      confirmLoading={submitting}
      okText="Gửi phê duyệt"
      cancelText="Hủy"
      width={560}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item name="approverIds" label="Người phê duyệt"
          rules={[{ required: true, message: 'Chọn ít nhất 1 người' }]}>
          <Select
            mode="multiple"
            showSearch
            optionFilterProp="label"
            placeholder="Chọn người phê duyệt..."
            loading={loading}
            options={users.map(u => ({
              value: u.id,
              label: `${u.fullName} — ${u.position ?? ''} (${u.department?.name ?? ''})`,
            }))}
          />
        </Form.Item>

        <Form.Item name="workflow" label="Luồng phê duyệt" rules={[{ required: true }]}
          extra="Tuần tự: theo thứ tự chọn · Song song: ai duyệt trước cũng được">
          <Radio.Group>
            <Radio.Button value="SEQUENTIAL">Tuần tự</Radio.Button>
            <Radio.Button value="PARALLEL">Song song</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item name="comment" label="Ghi chú (tùy chọn)">
          <Input.TextArea rows={2} placeholder="Lời nhắn cho người phê duyệt..." />
        </Form.Item>
      </Form>
    </Modal>
  );
}
